import { Component, Fragment, h, Host, Prop } from "@stencil/core";
import { dealerSearchResultsStore } from "@phn/state/dealer-search-results-store";
import { JSX } from "@stencil/core/internal";
import { navContentStore } from "@phn/state/nav-content-store";
import { isMobile } from "@phn/utility/helper";
import { DealerSearchFormItemCard } from "./dealer-search-form-item-card";
import ErrorMessage from "../dealer-search-form/error-message";

@Component({
  tag: "phn-nd-dealer-search-results",
  styleUrl: "dealer-search-results.scss",
  scoped: true,
})
export class DealerSearchResults {
  @Prop() showOverlay = false;

  @Prop() locale!: string;

  @Prop() breakpoint!: number;

  @Prop() hasMapLink!: boolean;

  render(): JSX.Element | null {
    const { results, ppnDealers } = dealerSearchResultsStore.state;
    const { error: errorContent } = navContentStore.state;

    if (results === null) return null;

    if (results?.length === 0)
      return (
        <Fragment>
          <ErrorMessage
            errorMessage={errorContent.noResults}
            onDismiss={() => null}
          />
        </Fragment>
      );
    const dealerId = results[0];
    if (results.length === 1 && ppnDealers[dealerId]) {
      return (
        <phn-nd-dealer-card
          locale={this.locale}
          dealer={ppnDealers[dealerId]}
          class="router-dealer-card"
          isFlyout={isMobile(this.breakpoint)}
          singleResult={results?.length === 1}
          role="listitem"
        />
      );
    }

    return (
      <Host>
        <Fragment>
          {results.map((dealerId) => {
            const dealer = ppnDealers[dealerId];

            if (dealer?.ppnDealer === undefined) {
              return null;
            }
            return (
              <DealerSearchFormItemCard dealer={dealer} locale={this.locale} />
            );
          })}
        </Fragment>
      </Host>
    );
  }
}
